const UPDATE_TIME = 15000; // 15 seconds
const APPEARIN_TIME = 1000; // 15 seconds

export { UPDATE_TIME, APPEARIN_TIME };



// WEBPACK FOOTER //
// ./src/constants.js